import { ViewportToolsetSubButton } from "@/viewport-tools/core";
import type {
  ScaleToolsetRailController,
  ViewportToolsetRailRendererResult,
} from "@/viewport-tools/rail/types";
import {
  CALIBRATION_METHOD_IDS,
  SCALE_TOOL_IDS,
  SCALE_TOOLSET,
  getScaleToolDefinition,
} from "./registry";
import { PresetCalibrationPanel } from "@/viewport-tools/scale/preset-calibration-panel";
import { ManualCalibrationPopover } from "@/viewport-tools/scale/manual-calibration-popover";

export function renderScaleToolsetRail(
  controller: ScaleToolsetRailController
): ViewportToolsetRailRendererResult {
  const presetScaleTool = getScaleToolDefinition(SCALE_TOOL_IDS.preset);
  const calibrateScaleTool = getScaleToolDefinition(SCALE_TOOL_IDS.calibrate);
  const ScaleToolIcon = presetScaleTool.icon;

  return {
    item: {
      id: SCALE_TOOLSET.id,
      icon: <ScaleToolIcon className="size-4" />,
      label: SCALE_TOOLSET.label,
      active: controller.isCalibrating || controller.isSubMenuOpen,
      selected: controller.expanded,
      onClick: () => controller.setExpanded(!controller.expanded),
    },
    inlineContent: controller.expanded ? (
      <div className="relative">
        <div className="flex flex-col">
          <ViewportToolsetSubButton
            icon={<ScaleToolIcon className="size-4" />}
            label={calibrateScaleTool.label}
            active={controller.isManualMode}
            onClick={() =>
              controller.selectScaleCalibrationMethod(CALIBRATION_METHOD_IDS.manual)
            }
          />
          <ViewportToolsetSubButton
            icon={<ScaleToolIcon className="size-4" />}
            label={presetScaleTool.label}
            active={controller.isPresetMode}
            onClick={controller.openScalePresetMode}
          />
        </div>

        {controller.isPresetMode &&
        controller.pagePixelWidth &&
        controller.pagePixelHeight ? (
          <div className="pointer-events-none absolute left-[60px] top-[60px] z-40">
            <PresetCalibrationPanel
              currentScale={controller.currentScale}
              pagePixelWidth={controller.pagePixelWidth}
              pagePixelHeight={controller.pagePixelHeight}
              onApplyPreset={controller.applyScalePreset}
              onCancel={controller.cancelScaleCalibration}
            />
          </div>
        ) : null}

        {controller.isManualMode &&
        controller.calibrationState.phase === "second_point_set" ? (
          <div className="pointer-events-none absolute left-[60px] top-0 z-40">
            <ManualCalibrationPopover
              customDistanceInput={controller.customDistanceInput}
              validationError={controller.validationError}
              onCustomDistanceInputChange={(value) => {
                controller.setCustomDistanceInput(value);
                if (controller.validationError) {
                  controller.setValidationError(null);
                }
              }}
              onApply={() => void controller.applyScaleFromDistanceInput()}
              onCancel={controller.cancelScaleCalibration}
            />
          </div>
        ) : null}
      </div>
    ) : null,
  };
}
